import styled from "styled-components";
import Variables from "../../../../assets/styleVariables";

export const Container = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  z-index: 999999;
  background-color: rgba(256, 256, 256, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Box = styled.div`
  background-color: ${Variables.colors.complementary};
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.2);
  width: 472.5px;
  padding: 16px;
  max-height: 95vh;
  overflow-y: auto;
  .header {
    display: flex;
    justify-content: space-between;
    .title {
      display: flex;
      color: ${Variables.colors.complementary_700};
      font-size: ${Variables.font_sizes.x_medium};
      i {
        color: ${Variables.colors.primary_vivid};
        font-size: ${Variables.font_sizes.x2_medium};
        margin-left: 16px;
      }
    }
  }
  .titles {
    width: 50%;
    margin: 16px 0;
  }
  textarea {
    min-width: 90%;
    max-width: 90%;
    min-height: 175px;
    margin-top: 16px;
    border: solid 1px ${Variables.colors.complementary_500};
    border-radius: 4px;
    padding: 8px;
  }
  .hint{
    margin-top: 8px;
    margin-bottom: 16px;
    font-size: ${Variables.font_sizes.medium};
    color: ${Variables.colors.complementary_700};
  }
  .error {
    margin-bottom: 8px;
    display: block;
    padding: 4px 0;
    font-size: 12px;
    color: #a90021;
  }
  .file-notice {
    color: ${Variables.colors.complementary_600};
    font-size: ${Variables.font_sizes.small};
    width: 75%;
    margin: 16px 0;
    line-height: 1.58;
  }
  .buttons {
    width: 100%;
    margin-top: 32px;
    display: flex;
    justify-content: flex-end;
  }
`;
